import { Group } from '@chakra-ui/react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'

import { Button, ButtonProps } from '@/components/ui/button'

type ItemNav = ButtonProps & { title?: string }

export const PrevNextNav = ({
  prev,
  next,
}: {
  prev?: ItemNav
  next?: ItemNav
}) => {
  const baseButtonProps: ButtonProps = {
    size: { base: 'lg', md: 'xl' },
    alignSelf: { base: 'stretch', sm: 'start' },
  }

  const { title: prevTitle, ...prevProps } = prev || {}
  const { title: nextTitle, ...nextProps } = next || {}

  return (
    <Group attached>
      {(prev && (
        <Button {...baseButtonProps} {...prevProps}>
          <FaChevronLeft />
          {prevTitle && prevTitle}
        </Button>
      )) || (
        <Button {...baseButtonProps} disabled={true}>
          <FaChevronLeft />
        </Button>
      )}
      {(next && (
        <Button {...baseButtonProps} {...nextProps}>
          {nextTitle && nextTitle}
          <FaChevronRight />
        </Button>
      )) || (
        <Button {...baseButtonProps} disabled={true}>
          <FaChevronRight />
        </Button>
      )}
    </Group>
  )
}
